import React from 'react';
import EditableTextarea from '../Common/EditableTextarea';
import { Card } from 'react-bootstrap';

import './FinalReflection.sass';

const FinalReflection = ({ content, save }) => (
  <div className="box box-row">
    <div className="box editor">
      <EditableTextarea
        title="Final Reflection"
        save={save}
        identifier="reflection"
        content={content}
        className="h-100"
      />
    </div>
    <div className="box instructions">
      <Card className="panel-scroll" variant="default">
        <Card.Header>
          <Card.Title>What's This?</Card.Title>
        </Card.Header>
        <Card.Body>
          <p>
            Write about what you have done during the engineering design
            process.
          </p>
          <ul>
            <li>Explain the engineering problem you needed to solve.</li>
            <li>
              What steps did you go through to solve this problem? Explain the
              process of using virtual (computer) modeling and simulation
              software to reach a solution.
            </li>
            <li>
              Talk about how you built and tested your physical model. How did
              it perform?
            </li>
            <li>
              Concluding Statement: Given what you did during this engineering
              design process, what would you like to say about your{' '}
              <em>final design</em>? Did it look and work like you expected?
            </li>
          </ul>
        </Card.Body>
      </Card>
    </div>
  </div>
);

export default FinalReflection;
